module.exports = __webpack_public_path__ + "img/image2.859635e7.png";